(function initializeProductLayout() {
  function bind(root) {
    if (root.dataset.productLayoutReady === 'true') return;
    root.dataset.productLayoutReady = 'true';

    const desktop = window.matchMedia('(min-width: 750px)');
    const media = root.querySelector('.product-media');
    const gallery = media?.querySelector('[data-product-inline-gallery]');
    const items = gallery ? [...gallery.querySelectorAll('[data-media-id]')] : [];
    const selectors = media ? [...media.querySelectorAll('[data-product-media-select]')] : [];
    const autoplay = media?.querySelector('[data-product-media-autoplay]');
    const previous = media?.querySelector('[data-product-media-previous]');
    const next = media?.querySelector('[data-product-media-next]');
    const automaticItems = items.filter((item) => item.querySelector('.product-gallery__open img') || item.querySelector('video'));
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const description = root.querySelector('[data-product-description]');
    const body = description?.querySelector('[data-product-description-body]');
    const toggle = description?.querySelector('[data-product-description-toggle]');
    const descriptionAccordion = description?.closest('[data-product-description-accordion]');
    if (descriptionAccordion) descriptionAccordion.open = desktop.matches;
    let activeId = items[0]?.dataset.mediaId;
    let pendingId;
    let scrollFrame;
    let automaticTimer;
    let automaticStopped = false;
    let galleryVisible = true;
    let galleryHovered = false;
    let galleryFocused = false;
    const mobile = window.matchMedia('(max-width: 749px)');
    const resetImageZoom = [...(gallery?.querySelectorAll('[data-product-gallery-open]') || [])].map((opener) => (
      window.MonciProductTouchZoom?.bind(opener, { mobile, onInteraction: stopAutoplay }) || (() => {})
    ));
    let selectedId = activeId;

    function canAutoplay() {
      return Boolean(autoplay && automaticItems.length > 1 && !reducedMotion.matches && !automaticStopped
        && !document.hidden && galleryVisible && !galleryFocused
        && !(desktop.matches && galleryHovered) && root.isConnected);
    }

    function nextAutomaticItem() {
      return automaticItems[(automaticItems.findIndex((item) => item.dataset.mediaId === activeId) + 1)
        % automaticItems.length];
    }

    function advanceAutomatic() {
      if (!canAutoplay()) return;
      select(nextAutomaticItem().dataset.mediaId);
      updateAutoplay();
    }

    function updateAutoplay() {
      clearTimeout(automaticTimer);
      if (!autoplay) return;
      autoplay.hidden = automaticItems.length < 2 || reducedMotion.matches;
      autoplay.setAttribute('aria-pressed', String(automaticStopped));
      const label = automaticStopped ? autoplay.dataset.playLabel : autoplay.dataset.pauseLabel;
      autoplay.setAttribute('aria-label', label);
      autoplay.title = label;
      autoplay.querySelector('[data-product-media-autoplay-symbol]').textContent = automaticStopped ? '▶' : 'Ⅱ';
      const video = items.find((item) => item.dataset.mediaId === activeId)?.querySelector('video');
      if (video) video.loop = !canAutoplay();
      if (!canAutoplay() || video) return;
      const next = nextAutomaticItem();
      const nextImage = next.querySelector('img');
      if (nextImage) nextImage.loading = 'eager';
      automaticTimer = setTimeout(advanceAutomatic, 3000);
    }

    function stopAutoplay() {
      automaticStopped = true;
      updateAutoplay();
    }

    function updateVideoPlayback() {
      items.forEach((item) => {
        item.querySelectorAll('video').forEach((video) => {
          if (item.dataset.mediaId === activeId && galleryVisible && !document.hidden) {
            video.muted = true;
            video.loop = !canAutoplay();
            video.controls = false;
            if (video.paused) video.play().catch(() => {
              if (item.dataset.mediaId === activeId && canAutoplay()) {
                clearTimeout(automaticTimer);
                automaticTimer = setTimeout(advanceAutomatic, 3000);
              }
            });
          } else video.pause();
        });
      });
    }

    function updateSelectors() {
      updateVideoPlayback();
      if (selectedId !== activeId) resetImageZoom.forEach((reset) => reset());
      selectedId = activeId;
      selectors.forEach((button) => {
        if (button.dataset.productMediaSelect === activeId) {
          button.setAttribute('aria-current', 'true');
        } else {
          button.removeAttribute('aria-current');
        }
      });
      const index = items.findIndex((item) => item.dataset.mediaId === activeId);
      if (previous) {
        previous.hidden = index <= 0;
        previous.disabled = previous.hidden;
      }
      if (next) {
        next.hidden = index < 0 || index >= items.length - 1;
        next.disabled = next.hidden;
      }
      const selected = selectors.find((button) => button.dataset.productMediaSelect === activeId);
      const rail = selected?.parentElement;
      if (!desktop.matches && rail) {
        const buttonBounds = selected.getBoundingClientRect();
        const railBounds = rail.getBoundingClientRect();
        if (buttonBounds.left < railBounds.left || buttonBounds.right > railBounds.right) {
          rail.scrollTo({
            left: rail.scrollLeft + buttonBounds.left - railBounds.left - (rail.clientWidth - selected.offsetWidth) / 2,
            behavior: reducedMotion.matches ? 'auto' : 'smooth',
          });
        }
      }
    }

    function select(id, scroll = true) {
      const target = items.find((item) => item.dataset.mediaId === id);
      if (!target) return;
      activeId = id;
      pendingId = !desktop.matches && scroll ? id : undefined;
      const visibleIds = [id];
      items.forEach((item) => {
        item.classList.toggle('is-gallery-active', item === target);
        const hidden = desktop.matches && !visibleIds.includes(item.dataset.mediaId);
        if (hidden) item.querySelectorAll('video').forEach((video) => video.pause());
        item.hidden = hidden;
      });
      updateSelectors();
      if (!desktop.matches && scroll) {
        gallery.scrollTo({
          left: target.offsetLeft - items[0].offsetLeft,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      }
    }

    function navigate(direction) {
      const index = items.findIndex((item) => item.dataset.mediaId === activeId);
      const target = items[index + direction];
      if (!target) return;
      stopAutoplay();
      select(target.dataset.mediaId);
    }

    if (items.length) {
      media.classList.add('is-enhanced');
      items.forEach((item) => item.querySelectorAll('video').forEach((video) => {
        const advanceVideo = () => {
          if (item.dataset.mediaId === activeId) advanceAutomatic();
        };
        video.addEventListener('ended', advanceVideo);
        video.addEventListener('error', advanceVideo);
      }));
      previous?.addEventListener('click', () => navigate(-1));
      next?.addEventListener('click', () => navigate(1));
      selectors.forEach((button) => {
        button.addEventListener('click', () => {
          stopAutoplay();
          select(button.dataset.productMediaSelect);
        });
      });
      media.addEventListener('pointerdown', (event) => {
        if (event.target.closest('[data-product-inline-gallery]')) pendingId = undefined;
        if (!event.target.closest('[data-product-media-autoplay]')) stopAutoplay();
      }, { passive: true });
      gallery.addEventListener('click', stopAutoplay);
      gallery.addEventListener('wheel', () => {
        pendingId = undefined;
        stopAutoplay();
      }, { passive: true });
      gallery.addEventListener('mouseenter', () => {
        galleryHovered = true;
        updateAutoplay();
      });
      gallery.addEventListener('mouseleave', () => {
        galleryHovered = false;
        updateAutoplay();
      });
      media.addEventListener('focusin', (event) => {
        galleryFocused = !event.target.closest('[data-product-media-autoplay]');
        updateAutoplay();
      });
      media.addEventListener('focusout', (event) => {
        galleryFocused = media.contains(event.relatedTarget) && event.relatedTarget !== autoplay;
        updateAutoplay();
      });
      autoplay?.addEventListener('click', () => {
        automaticStopped = !automaticStopped;
        updateAutoplay();
      });
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {
          galleryVisible = entry.isIntersecting;
          updateVideoPlayback();
          updateAutoplay();
        }, { threshold: 0.15 });
        observer.observe(gallery);
      }
      document.addEventListener('visibilitychange', () => {
        updateVideoPlayback();
        updateAutoplay();
      });
      reducedMotion.addEventListener('change', updateAutoplay);
      gallery.addEventListener('scroll', () => {
        if (desktop.matches || scrollFrame) return;
        scrollFrame = requestAnimationFrame(() => {
          const start = gallery.getBoundingClientRect().left;
          const nearestId = items.reduce((nearest, item) => (
            Math.abs(item.getBoundingClientRect().left - start)
              < Math.abs(nearest.getBoundingClientRect().left - start) ? item : nearest
          )).dataset.mediaId;
          if (!pendingId || pendingId === nearestId) {
            activeId = nearestId;
            pendingId = undefined;
            updateSelectors();
          }
          scrollFrame = null;
        });
      }, { passive: true });
      root.querySelectorAll('[data-option-group] input, [data-option-group] select').forEach((input) => {
        input.addEventListener('change', () => {
          stopAutoplay();
          const json = root.querySelector('[data-variants-json]');
          if (!json) return;
          try {
            const values = [...root.querySelectorAll('[data-option-group]')].map((group) => (
              group.querySelector('input:checked, select')?.value
            ));
            const variant = JSON.parse(json.textContent).find((entry) => (
              entry.options?.every((value, index) => value === values[index])
            ));
            const id = variant?.featured_media?.id;
            if (id) select(String(id), false);
          } catch {}
        });
      });
      select(activeId, false);
      updateAutoplay();
    }

    function updateDescription() {
      if (!body || !toggle) return;
      const lineHeight = Number.parseFloat(getComputedStyle(body).lineHeight);
      const collapsible = desktop.matches && body.scrollHeight > lineHeight * 3 + 2;
      description.classList.toggle('is-collapsible', collapsible);
      toggle.hidden = !collapsible;
      if (!collapsible) description.classList.remove('is-expanded');
      const expanded = description.classList.contains('is-expanded');
      toggle.setAttribute('aria-expanded', String(expanded));
      toggle.textContent = expanded ? toggle.dataset.collapseLabel : toggle.dataset.expandLabel;
    }

    toggle?.addEventListener('click', () => {
      description.classList.toggle('is-expanded');
      updateDescription();
    });
    desktop.addEventListener('change', () => {
      if (descriptionAccordion) descriptionAccordion.open = desktop.matches;
      resetImageZoom.forEach((reset) => reset());
      if (items.length) select(activeId, !desktop.matches);
      updateDescription();
      updateAutoplay();
    });
    window.addEventListener('resize', updateDescription, { passive: true });
    description?.closest('details')?.addEventListener('toggle', updateDescription);
    document.fonts?.ready.then(updateDescription);
    updateDescription();
  }

  function initialize(scope = document) {
    if (scope.matches?.('[data-product-root]')) bind(scope);
    scope.querySelectorAll('[data-product-root]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
